export default () => {
  const tooltipButtons = document.querySelectorAll('[data-tooltip-trigger]');

  tooltipButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const tooltip = button.nextElementSibling;
      const tooltipClose = tooltip?.firstElementChild;

      if (tooltip && tooltipClose) {
        tooltip.classList.toggle('active');
        button.classList.toggle('active');

        tooltipClose.addEventListener('click', (event) => {
          event.stopPropagation();
          tooltip.classList.remove('active');
          button.classList.remove('active');
        });
      }
    });
  });
};
